export var FetchBtiStateType;
(function (FetchBtiStateType) {
    FetchBtiStateType["SETTLED"] = "settled";
    FetchBtiStateType["UNSETTLED"] = "unsettled";
    FetchBtiStateType["NOT_FOUND"] = "not_found";
    FetchBtiStateType["IGNORED"] = "ignored";
})(FetchBtiStateType || (FetchBtiStateType = {}));
//# sourceMappingURL=FetchBtiStateType.js.map